var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [{ name: "responsive", rawName: "v-responsive" }],
          staticClass: "bar no-border",
          class: _vm.$style.bar,
        },
        [
          _c(
            "hd-select",
            {
              attrs: { dark: true, items: _vm.groupers },
              model: {
                value: _vm.groupBy,
                callback: function ($$v) {
                  _vm.groupBy = $$v
                },
                expression: "groupBy",
              },
            },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons",
                  attrs: { slot: "icon" },
                  slot: "icon",
                },
                [_vm._v(" calendar_view_day ")]
              ),
              !_vm.groupBy
                ? _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(" Group By "),
                  ])
                : _vm._e(),
            ]
          ),
          _vm.groupBy
            ? _c(
                "hd-select",
                {
                  attrs: { dark: true, items: _vm.filters },
                  model: {
                    value: _vm.filterBy,
                    callback: function ($$v) {
                      _vm.filterBy = $$v
                    },
                    expression: "filterBy",
                  },
                },
                [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      attrs: { slot: "icon" },
                      slot: "icon",
                    },
                    [_vm._v(" filter_list ")]
                  ),
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Filter By"),
                  ]),
                ]
              )
            : _vm._e(),
          _c("div", { class: _vm.$style.controls }, [
            _vm.isManagingNotes
              ? _c(
                  "button",
                  {
                    staticClass: "aBtn asLarge atDark asMain",
                    attrs: {
                      title:
                        _vm.selectedProperties.length === 0
                          ? "Please select at least one hotel"
                          : "",
                      disabled: _vm.selectedProperties.length === 0,
                      "data-icon": "notes",
                    },
                    on: { click: _vm.openNotesDialog },
                  },
                  [_vm._v(" Manage notes ")]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "button dark icon-only",
                on: { click: _vm.editColumns },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("settings"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "rbTooltip simple",
                    attrs: { tooltip: "placement:end-middle" },
                  },
                  [_vm._v(" Organise Table Columns ")]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "rb-virtual-list",
        {
          directives: [
            { name: "responsive-table", rawName: "v-responsive-table" },
          ],
          staticClass: "manage-table",
          class: {
            [_vm.$style.table]: true,
            [_vm.$style.fullTable]: _vm.hotels && _vm.hotels.length > 0,
          },
          attrs: { items: _vm.sortedAndGrouped },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (item) {
                return [
                  item.item.type === "group" &&
                  item.item.key &&
                  item.item.key !== "none"
                    ? _c(
                        "div",
                        { staticClass: "grouper" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons check-box",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleGroup(item.item.key)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.allAddedInGroup(item.item.key)
                                      ? "check_box"
                                      : _vm.someAddedInGroup(item.item.key)
                                      ? "indeterminate_check_box"
                                      : "check_box_outline_blank"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.groupBy === "rating"
                            ? _c("rb-rating", {
                                attrs: { rate: item.item.key },
                              })
                            : _vm.groupBy === "validity"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.item.key ? "Valid" : "With Errors"
                                  )
                                ),
                              ])
                            : _vm.groupBy === "added"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.item.key
                                      ? "On Directory"
                                      : "Not on Directory"
                                  )
                                ),
                              ])
                            : _c("span", [_vm._v(_vm._s(item.item.key))]),
                        ],
                        1
                      )
                    : _c("table-row", {
                        key: item.item[_vm.id],
                        class: _vm.$style.table,
                        attrs: {
                          row: item.item,
                          added: _vm.isItemAdded(item.item),
                          columns: _vm.columns,
                          rate: _vm.shownRate,
                          "visible-columns": _vm.visibleColumns || 1,
                          open: _vm.openedRow === item.item[_vm.id],
                          "property-code": _vm.propertyCodeShown,
                          "property-codes": _vm.propertyCodes,
                          updating:
                            _vm.updatingRows.indexOf(item.item[_vm.id]) >= 0,
                          "visible-column-styles": _vm.visibleColumnStyles,
                          "is-managing-notes": _vm.isManagingNotes,
                        },
                        on: {
                          add: _vm.add,
                          remove: _vm.remove,
                          openFinalAgreement: _vm.openFinalAgreement,
                          open: _vm.openRow,
                        },
                      }),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "before" }, [
            _c(
              "div",
              { staticClass: "row tableHead" },
              [
                _c("div", { staticClass: "cell head checkboxHead" }, [
                  _vm.isManagingNotes
                    ? _c(
                        "span",
                        {
                          staticClass: "material-icons check-box",
                          on: { click: _vm.toggleAll },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.selectedPropertyIds.length ===
                                  _vm.filteredHotels.length
                                  ? "check_box"
                                  : _vm.selectedPropertyIds.length > 0
                                  ? "indeterminate_check_box"
                                  : "check_box_outline_blank"
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._l(_vm.columns, function (column) {
                  return [
                    column === "rates"
                      ? _c(
                          "div",
                          {
                            key: column,
                            staticClass: "cell head",
                            class: _vm.$style.rateColumn,
                            style: _vm.getColumn(column).style,
                            attrs: { title: _vm.rate.text },
                          },
                          [
                            _c(
                              "hd-select",
                              {
                                staticClass: "dark-background",
                                class: _vm.$style.rateDropdown,
                                attrs: { dark: true, items: _vm.rates },
                                model: {
                                  value: _vm.shownRate,
                                  callback: function ($$v) {
                                    _vm.shownRate = $$v
                                  },
                                  expression: "shownRate",
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("info"),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "rbTooltip simple",
                                    attrs: {
                                      tooltip: "placement:bottom-start",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " Use this dropdown to change the rate type showing in the table "
                                    ),
                                  ]
                                ),
                                _vm._v(" " + _vm._s(_vm.rate.name) + " "),
                              ]
                            ),
                          ],
                          1
                        )
                      : column === "code"
                      ? _c(
                          "div",
                          {
                            key: column + "-code",
                            staticClass: "cell head",
                            class: _vm.$style.rateColumn,
                            style: _vm.getColumn(column).style,
                            attrs: { title: _vm.propertyCode.text },
                          },
                          [
                            _c(
                              "hd-select",
                              {
                                staticClass: "dark-background",
                                class: _vm.$style.rateDropdown,
                                attrs: { dark: true, items: _vm.propertyCodes },
                                model: {
                                  value: _vm.propertyCodeShown,
                                  callback: function ($$v) {
                                    _vm.propertyCodeShown = $$v
                                  },
                                  expression: "propertyCodeShown",
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("info"),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "rbTooltip simple",
                                    attrs: {
                                      tooltip: "placement:bottom-start",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " Use this dropdown to change the property code type showing in the table "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  " " + _vm._s(_vm.propertyCode.name) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            key: column + "-other",
                            staticClass: "cell head",
                            style: _vm.getColumn(column).style,
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.getColumn(column).text) + " "
                            ),
                          ]
                        ),
                  ]
                }),
              ],
              2
            ),
          ]),
        ],
        2
      ),
      _vm.empty
        ? _c(
            "div",
            { class: _vm.$style.empty },
            [
              _vm.loading
                ? _c(
                    "div",
                    {
                      staticClass: "layout-column flex-center",
                      class: _vm.$style.loader,
                    },
                    [
                      _c("rbv-loading", {
                        attrs: { label: "Loading, please wait..." },
                      }),
                    ],
                    1
                  )
                : [
                    _c("div", { class: _vm.$style.emptyTitle }, [
                      _vm._v("Nothing to see here (:"),
                    ]),
                    _c("div", { class: _vm.$style.emptySubTitle }, [
                      _vm._v(
                        " Your Hotel Directory shows only those hotels to which you have sent Final Agreements on behalf of your company. "
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "button dark",
                          on: {
                            click: function ($event) {
                              return _vm.bidManager()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("list_alt"),
                          ]),
                          _vm._v(" Bid Manager "),
                        ]
                      ),
                    ]),
                  ],
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }